import { create } from "zustand";

const initialState = {
  recipient: "",
  selectedRecipient: null,
  search: "",
  role: "MEMBER",
  projectRole: "COLLABORATOR",
  allProjectsAccess: true,
  projectIds: [],
  error: null,
};

export const useTeamInviteStore = create((set) => ({
  ...initialState,

  setRecipient: (recipient) => {
    const nextRecipient = recipient || "";
    set({
      recipient: nextRecipient,
      selectedRecipient: null,
      search: nextRecipient.trim().length >= 2 ? nextRecipient.trim() : "",
      error: null,
    });
  },

  selectRecipient: (selectedRecipient) =>
    set({
      recipient: selectedRecipient?.email || "",
      selectedRecipient,
      search: "",
      error: null,
    }),

  clearRecipient: () =>
    set({ recipient: "", selectedRecipient: null, search: "", error: null }),

  setRole: (role) => set({ role }),
  setProjectRole: (projectRole) => set({ projectRole }),
  setAllProjectsAccess: (allProjectsAccess) =>
    set((state) => ({
      allProjectsAccess,
      projectIds: allProjectsAccess ? [] : state.projectIds,
    })),
  toggleProject: (projectId) =>
    set((state) => ({
      projectIds: state.projectIds.includes(projectId)
        ? state.projectIds.filter((id) => id !== projectId)
        : [...state.projectIds, projectId],
    })),
  setError: (error) => set({ error }),
  reset: () => set(initialState),
}));
